import { OnInit, AfterViewInit, Component, TemplateRef, ViewChild, ViewContainerRef, ElementRef, Injector, Input, signal } from '@angular/core';
import { AnimationEvent, trigger, state, style, animate, transition, query, group, animateChild } from '@angular/animations';
import { Overlay, OverlayPositionBuilder, OverlayRef, PositionStrategy } from '@angular/cdk/overlay';
import { ComponentPortal, DomPortal, Portal, TemplatePortal } from '@angular/cdk/portal';
import { Subscription } from 'rxjs';
import { BrowserSnifferService } from "../../services/browser-sniffer.service";
import { PermalinkService } from '../../services/permalink.service';
import Feature, { FeatureLike } from 'ol/Feature';
import { MarkerService } from '../../services/marker.service';
import { PopupData } from '../../interfaces/popup-data';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { SendMapRemarkPanelComponent } from './send-map-remark-panel/send-map-remark-panel.component';
import { MapService } from '../../services/map.service';
import { LayerService } from '../../services/layers/layer.service';
import { OlLayerService } from '../../services/ol/ol-layer.service';
import { MatDialog } from '@angular/material/dialog';
import { SendRemarkEmailDialogComponent } from './send-remark-email-dialog/send-remark-email-dialog.component';
import { PopupService } from '../../services/popup.service';
import { PopoverMsgComponent } from './popover-msg/popover-msg.component';
import { ToggleEventNameType, ToggleEventService, ToggleEventType } from '../../services/toggle-event.service';
import GeoJSON from 'ol/format/GeoJSON';
import { Geometry, Point } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Layer } from 'ol/layer';
import { Fill, Icon, RegularShape, Stroke, Style, Text, Circle, Image } from 'ol/style';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MapBrowserEvent } from 'ol';
import { unByKey } from 'ol/Observable';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GeoJsonLayer } from '../../models/geo-json-layer';
import { EventsKey } from 'ol/events';
import { PopoverService } from '../popover/popover.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Capacitor } from '@capacitor/core';
import { BackEventService } from '@tt-lib/services/back-event.service';

@Component({
  selector: 'tt-send-remark',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    TranslateModule
  ],
  templateUrl: './send-remark.component.html',
  styleUrls: ['./send-remark.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1.0,
        transform: 'scale(1.0)'
      })),
      state('close', style({
        opacity: 0.0,
        transform: 'scale(0.8)'
      })),
      transition('open => close',
        //animate('400ms cubic-bezier(0.0, 0.0, 0.2, 1)'))
        animate('150ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
      transition('close => open',
        //animate('400ms cubic-bezier(0.0, 0.0, 0.2, 1)'))
        animate('250ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
    ])
  ],
  standalone: true
})

export class SendRemarkComponent {
  @ViewChild('remarksSelect') remarksSelectTemplate: TemplateRef<unknown>;
  @ViewChild('remarksSelectButtonContainer') remarksSelectButtonContainer: Element;
  @Input() showIconOnPhone: boolean;
  // @Input() remarksSelectButton!: HTMLElement;

  private overlayRef: OverlayRef;
  private subscriptions: Subscription = new Subscription();
  private isAnimating: boolean;
  public isOpen = signal(false);
  public isPanelOpen = signal (false);
  public canCommentMap: boolean = false;
  public sheetRef;
  private formData = {
    firstName: '',
    lastName: '',
    email: '',
    message: '',
    keepInformed: true,
    poi: undefined,
    validateOnOpen: false
  }
  private remarksLayer: VectorLayer<any>;
  private mapClickListener: EventsKey = null;
  public isRemarksLayerVisible: boolean = false;
  private positionStrategyPhone: PositionStrategy;
  private positionStrategy: PositionStrategy;
  // private readonly remarksUrlString = '/geoserver/tmv/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=tmv:visible_remarks&outputFormat=application/json';
  // private readonly remarksUrlString = 'http://ign-sd-www-2.int.ngi.be:8080/geoserver/tmv/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=tmv:visible_remarks&outputFormat=application/json';
  // private readonly remarksUrlString = 'http://ign-sd-www-2.int.ngi.be:8080/geoserver/tmv/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=tmv:visible_remarks&outputFormat=application/json';
  // private readonly remarksUrlString = 'http://www-test/geoserver/tmv/wms?service=WFS&version=1.0.0&request=GetFeature&typeName=tmv:visible_remarks&outputFormat=application/json';
  // private readonly remarksUrlString = 'assets/JSON/grids/visible_remarks.geojson';
  //TODO make it dynamic
  private readonly remarksUrlString = 'https://topomapviewer.ngi.be/tmv-services/remarks/all';

  constructor(
    private overlay: Overlay,
    private _viewContainerRef: ViewContainerRef,
    private _elementRef: ElementRef<HTMLElement>,
    public browsersniffer: BrowserSnifferService,
    public permalinkService: PermalinkService,
    private markerService: MarkerService,
    private popupService: PopupService,
    private popoverService: PopoverService,
    private mapService: MapService,
    private layerService: LayerService,
    public dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
    private toggleEventService: ToggleEventService,
    private http: HttpClient,
    public olLayerService: OlLayerService,
    private translateService: TranslateService,
    private backEventService: BackEventService
    // private bottomSheetRef: MatBottomSheetRef<SendMapRemarkPanelComponent>,
  ) { 

     this.subscriptions.add(
          this.toggleEventService.emitter$.subscribe(
            (toggleEvent: ToggleEventType) => {
              if (toggleEvent.forwardedFor === 'send-remark' && toggleEvent.eventName === ToggleEventNameType.CLOSE_COMMAND) {
                  if (this.isOpen) {
                      this.close();
                  }
              }
            }
          )
        );
  }

  ngOnInit(): void {
 
    // opening with marker in link
    if (this.permalinkService.getUrlParam('marker') === 'cw.remark.point') {
      let xm = parseFloat(this.permalinkService.getUrlParam('xm').replace(/,/g, '.'));
      let ym = parseFloat(this.permalinkService.getUrlParam('ym').replace(/,/g, '.'));
      let zm = parseFloat(this.permalinkService.getUrlParam('zm').replace(/,/g, '.'));
      let feature = new Feature({
        geometry: new Point([xm, ym]),
        type: 'cw.remark.point',
        styleClass: 'remark'
      });
      feature.setProperties({ 'zoomlevel': zm })
      this.markerService.add(feature);
    }
    // adding remarks layer


    //setTimeout((_) => {
       //this.showEmailForm();
      // this.setMapRemarksInteraction();
      // this.open();
    //}, 5750);
    // setTimeout((_) => {
    //  this.setMapRemarksInteraction();
    // }, 750);

  }


  ngOnDestroy() {
    //!
    this.subscriptions.unsubscribe();
    if (this.overlayRef) { this.overlayRef.dispose(); }
    this.removeMapClickListener();
    this.mapService.removePointerCursorOnFeatureHoverForLayerId('remarksLayer');
  }

  ngAfterViewInit() {
    //setTimeout(() => this.toggle(), 1000)
    // setTimeout(()=> {
    //   this.bottomSheet.open(
    //     SendMapRemarkPanelComponent,
    //    // { data: { panelTemplate: 'chooseRemarkType' } }
    //   );
    // }, 2500)
    this.subscriptions.add(this.mapService.mapClickOnMarker$.subscribe((marker) => this.handleMarkerClick(marker)));
  }

  toggle() {
    this.isOpen() ? this.close() : this.open();
    // setTimeout(()=> this.openPanel(),200)
  }

  close() {
    this.isOpen.set(false);
    this.overlayRef?.detachBackdrop();
  }

  open() {
    if (this.isAnimating) return;
    this.checkMapRemarkAbility();
    if (!this.overlayRef) {
      this.positionStrategyPhone = this.overlay.position().global().centerHorizontally().centerVertically();
      this.positionStrategy = this.overlay.position()
        .flexibleConnectedTo(this.remarksSelectButtonContainer)
        //.flexibleConnectedTo(this._elementRef)      
        .withPositions([{
          originX: 'end',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'top'
        }])
        .withFlexibleDimensions(true);

      this.overlayRef = this.createOverlay();
      this.overlayRef.outsidePointerEvents().subscribe((event) => { this.close(); });
      // this.subscriptions.add(this.browsersniffer.subscribeToLayoutChanges().subscribe(() => {
      //   this.setBackdropClass();
      // }
      // ));
    }
    this.setBackdropClass();
    const drawerPortal = new TemplatePortal(this.remarksSelectTemplate, this._viewContainerRef);
    this.overlayRef.attach(drawerPortal);
    this.isOpen.set(true);

    this.backEventService.registerOpenedWindow({windowName: 'send-remark', isAutoCloseableWindow: true});
  }

  openPanel() {
    this.close();
    this.isPanelOpen.set(true);
    this.sheetRef = this.bottomSheet.open(SendMapRemarkPanelComponent, { hasBackdrop: false, panelClass: 'remark-bottomsheet' });
    // //! unsub
    this.sheetRef.afterDismissed().subscribe(() => {
      // console.log('after dismissed 1 ')
      this.isPanelOpen.set(false);
      this.toggleEventService.toggleEvent({
        eventName: ToggleEventNameType.CLOSE,
        forwardedFor: 'send-map-remark-panel',
      });
      // this.hideRemarksLayer();
    })

    this.toggleEventService.toggleEvent({
      eventName: ToggleEventNameType.OPEN,
      forwardedFor: 'send-map-remark-panel',
    });
    //this.showRemarksLayer();

    this.backEventService.registerOpenedWindow({windowName: 'SendMapRemarkPanelComponent', isAutoCloseableWindow: true});
  }

  toggleRemarksLayer() {
    this.isRemarksLayerVisible ? this.hideRemarksLayer() : this.showRemarksLayer();
  }

  private showRemarksLayer() {
    if (!this.remarksLayer) {
      this.createRemarksLayer();
    }

    this.isRemarksLayerVisible = true;
    this.remarksLayer.setVisible(this.isRemarksLayerVisible);

    this.setMapClickListener();
    this.mapService.setPointerCursorOnFeatureHoverForLayerId('remarksLayer');
  }

  private hideRemarksLayer() {
    this.isRemarksLayerVisible = false;
    this.remarksLayer.setVisible(this.isRemarksLayerVisible);

    this.removeMapClickListener();
    this.mapService.removePointerCursorOnFeatureHoverForLayerId('remarksLayer');
  }

  private createRemarksLayer() {
    this.remarksLayer = new GeoJsonLayer('remarksLayer', '', this.remarksUrlString, '').toOlLayer();
    this.remarksLayer.setZIndex(15);
    this.olLayerService.addOlLayerToMap(this.remarksLayer);
    console.log('create remarkslayer');

    console.dir(this.remarksLayer);

    this.remarksLayer.setStyle((feature: Feature, resolution: number) => {
      return this.getRemarksLayerStyle(feature, resolution);
    });
    this.popupService.onPopupClose$.subscribe(() => { this.removeHighlightStyle() });
  }

  private setMapClickListener() {
    if (this.mapClickListener === null) {
      this.mapClickListener = this.mapService
        .getCurrentMap()
        .on('click', (e: MapBrowserEvent<any>) => {
          let pixel = e.pixel;
          let remarkFeatures = this.mapService.getCurrentMap().getFeaturesAtPixel(pixel, {
            hitTolerance: 5,
            layerFilter: (l) => {
              return l.get('customId') === 'remarksLayer';
            },
          }) as Feature<Geometry>[];
          if (remarkFeatures.length > 0) {
            this.removeHighlightStyle();
            this.handleRemarksClick(remarkFeatures[0]);
          }
          else {
            this.removeHighlightStyle();
          }
        });
    }
  }

  private removeMapClickListener() {
    if (this.mapClickListener !== null) {
      unByKey(this.mapClickListener);
      this.mapClickListener = null;
    }
    if (this.popupService.isPopupAlreadyOnMap()) {
      this.popupService.hide();
    }
  }

  private handleRemarksClick(remarkFeature: Feature<Geometry>) {
    this.setHighlightStyle(remarkFeature);
    let point: Point = <Point>remarkFeature.getGeometry();
    let content = remarkFeature.get('remark') + '<br>' + '<br>';
    content += remarkFeature.get('sync_status') === 4 ?
      '<div class="visible-remark-caption sync4">' + this.translateService.instant('send-remark.visible-remark-status-4') + '</div>' :
      '<div class="visible-remark-caption sync3">' + this.translateService.instant('send-remark.visible-remark-status-3') + '</div>';
    let popupProperties: PopupData =
    {
      coordinates: point.getCoordinates(),
      type: 'remark',
      title: this.translateService.instant('send-remark.visible-remark-title'),
      content: content
    }
    window.setTimeout(() => { this.popupService.add(popupProperties); }, this.popupService.isPopupAlreadyOnMap() ? 300 : 0);
  }

  private setHighlightStyle(remarkFeature) {
    remarkFeature.set('highlight', true);
    remarkFeature.setStyle(
      new Style({
        zIndex: 5,

      })
    )
  }

  removeHighlightStyle() {
    this.remarksLayer.getSource().getFeatures().forEach(f => {
      if (f.get('highlight')) {
        f.set('highlight', false);
        f.setStyle();
      }
    });
  }

  private getRemarksLayerStyle(feature, resolution) {
    return [
      new Style({
        zIndex: 4,
        text: new Text({
          font: resolution > 30 ? '15px "NGI-IGN_ICONS"' : '21px "NGI-IGN_ICONS"',
          text: String.fromCharCode(0x2c4c),
          textAlign: 'center',
          offsetY: -11,
          fill: new Fill({
            //ngi green and darkblue
            color: feature.get('sync_status') === 4 ? 'rgba(47, 162, 152, 1.0)' : 'rgba(225, 62, 1, 1.0)'//ngiGreenBlueColor ngiOrangeColorDarker
          }),
          stroke: new Stroke({
            color: [255, 255, 255, 1.0],
            width: 3
          })
        })
      })
    ]
  }


  private displayPopup(marker: Feature) {
    let point: Point = <Point>marker.getGeometry();
    let content = 'x: ' + (<Point>marker.getGeometry()).getCoordinates()[0] + '<br>y: ' + (<Point>marker.getGeometry()).getCoordinates()[1] + '<br>zoomlevel: ' + marker.get('zoomlevel');
    let popupProperties: PopupData =
    {
      coordinates: point.getCoordinates(),
      type: marker.get('type'),
      title: 'Remark on cartoweb',
      content: content,
      zoomToFeatureLink: true,
      zoomlevel: marker.get('zoomlevel')
      //className: ''
    }
    this.popupService.add(popupProperties);
  }

  private handleMarkerClick(marker: Feature) {
    if (marker && marker.get('type') === 'cw.remark.point' && marker.get('highlight')) {
      this.displayPopup(marker);
    }
  }

  private setBackdropClass() {
    if (this.browsersniffer.isPhone()) {
      this.overlayRef?.updatePositionStrategy(this.positionStrategyPhone);
      setTimeout(() => {
        if (this.overlayRef?.backdropElement?.classList.contains('tt-backdrop-transparent')) {
          this.overlayRef?.backdropElement?.classList.remove('tt-backdrop-transparent');
        }
      }, 0);
    } else {
      this.overlayRef?.updatePositionStrategy(this.positionStrategy);
      setTimeout(() => {
        if (!this.overlayRef?.backdropElement?.classList.contains('tt-backdrop-transparent')) {
          this.overlayRef?.backdropElement?.classList.add('tt-backdrop-transparent');
        }
      }, 0);
    }
  }

  showCannotCommentMsg(target) {
    this.popoverService.open(
      PopoverMsgComponent,
      target.parentElement,
      {
        data: "send-remark.about_map.unavailable",
        // panelClass: ['center', 'top'],
        // panelOffset: 20,
        // arrowSize: 20
      },
      this._viewContainerRef
    )
  }

  private createOverlay(): OverlayRef {
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      disposeOnNavigation: true
      //backdropClass: 'tt-backdrop-transparent',
      // positionStrategy: positionStrategy
    });
    return this.overlayRef;
  }

  onAnimationEventStart(event: AnimationEvent) {
    this.isAnimating = true;
  }

  onAnimationEventEnd(event: AnimationEvent) {
    this.isAnimating = false;
    if (event.fromState === 'open' && event.phaseName === 'done') {
      // this.overlayRef.detach();
      this.overlayRef.dispose();
      this.overlayRef = undefined;
    }
  }

  showEmailForm() {

    this.toggleEventService.toggleEvent({
      eventName: ToggleEventNameType.OPEN,
      forwardedFor: 'send-email-remark',
    });
    //close remark if open
    if (this.bottomSheet._openedBottomSheetRef) {
      this.bottomSheet.dismiss();
      this.bottomSheet._openedBottomSheetRef.afterDismissed().subscribe(() => { this.openDialog(); })
      // if (this.sheetRef) {
      //   this.sheetRef.afterDismissed().subscribe(() => { this.openDialog(); })
      // }
    }
    else {
      this.openDialog();
    }
  }

  //open email dialog
  openDialog() {
    this.close();
   
    const dialogRef = this.dialog.open(SendRemarkEmailDialogComponent, {
      closeOnNavigation: true,
      panelClass: 'remark-dialog',
      data: {
        firstName: this.formData.firstName || "",
        lastName: this.formData.lastName || "",
        email: this.formData.email || "",
        message: this.formData.message || '',
        keepInformed: this.formData.keepInformed,
        validateOnOpen: this.formData.validateOnOpen || false
      }
    });


    dialogRef.afterClosed().subscribe(formData => {
      this.formData = formData[0];
      this.formData.validateOnOpen = formData[1];
      this.toggleEventService.toggleEvent({
        eventName: ToggleEventNameType.CLOSE,
        forwardedFor: 'send-email-remark',
      });
    });

     this.backEventService.registerOpenedWindow({windowName: 'SendRemarkEmailDialogComponent', isAutoCloseableWindow: true});
  }

  setMapRemarksInteraction() {
    //z-index
    let olContainer = document.querySelector('.ol-overlaycontainer-stopevent') as HTMLElement;
    if (this.isPanelOpen()) {
      this.bottomSheet.dismiss();
      this.close();
      olContainer.style.zIndex = '0';
    } else {
      this.openPanel();
      let olContainer = document.querySelector('.ol-overlaycontainer-stopevent') as HTMLElement;
      olContainer.style.zIndex = '2';
    }
  }

  public checkMapRemarkAbility() {
    // let suitableLayerTags = ["cartoweb-topo"]
    let suitableLayerTags = ["cartoweb.be"];
    //console.dir(this.layerService.getSelectedBaselayer())
    let baseLayer = this.layerService.getSelectedBaselayer().label.toLocaleLowerCase();
    this.canCommentMap = false;
    suitableLayerTags.forEach(layerTag => {
      if (baseLayer.indexOf("cartoweb") != -1) {
        this.canCommentMap = true;
      }
    });
  }

}